// Handlers para fechar modais ao clicar no fundo (overlay), sem fechar
// acidentalmente quando o utilizador seleciona texto num campo e solta o rato
// fora da caixa do modal. So fecha quando o mousedown E o mouseup ocorrem
// diretamente sobre o elemento do overlay (nao sobre o conteudo).
export function overlayCloseHandlers(onClose) {
  let downOnOverlay = false;
  return {
    onMouseDown: (e) => { downOnOverlay = e.target === e.currentTarget; },
    onMouseUp: (e) => {
      if (downOnOverlay && e.target === e.currentTarget) onClose();
      downOnOverlay = false;
    },
  };
}
